import './bootstrap';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic/build/ckeditor';

import $ from 'jquery';
window.$ = window.jQuery = $;


import AOS from 'aos';

window.AOS = AOS;
window.$ = window.jQuery = $;

import 'jquery-ui/ui/widgets/datepicker.js';
import 'jquery-ui/ui/widgets/autocomplete.js';

window.ClassicEditor = ClassicEditor;